export default __webpack_public_path__ + "5fa5edc6120923f04138e04314087f82.png";